<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <!-- No filter or sort content -->

      <template v-slot:list>
        <ListPane :getListMethod="getArticleLogListFromFilter" :optional-filters="filters"
          :locked-filters="{ ArticleIdList: [articleId] }" :paginationEnabled="true" :show-filter-tab="false"
          :show-sorting-tab="false" :itemsPerPage="100" :pk="pk">

          <template v-slot:list-item="{ item }">
            <v-row no-gutters justify="space-between" class="py-2">
              <v-col cols="auto" class="px-3">
                <p class="mb-0">{{ i18nFormatDateTime(item.TimeStamp) }}</p>
              </v-col>
              <v-col cols="2" class="px-3">
                <UserChip v-if="item.User" :user="item.User" :index="0" :typecolored="true">
                </UserChip>
                <p v-else class="mb-0">{{ item.UserDisplayName }}</p>
              </v-col>
              <v-col cols="0" class="px-3" style="white-space: pre-line" v-html="item.Text">
              </v-col>
            </v-row>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import UserChip from "@/components/Buttons/UserChip.vue";

export default {
  name: "ArticleLogList",
  props: {},
  components: {
    ListPane,
    Layout,
    UserChip,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ALL-",
    };
  },

  mounted() { },

  methods: {},

  computed: {
    articleId() { return this.$route.params.articleId; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>